import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BankAccountsService } from 'src/app/shared/services/bank-accounts.service';

@Component({
  selector: 'app-admin-overview',
  templateUrl: './admin-overview.component.html',
  styleUrls: ['./admin-overview.component.scss']
})
export class AdminOverviewComponent {
  isExecutingFullRescync: boolean = false;
  constructor(private bankSvc: BankAccountsService, private _snackBar: MatSnackBar) {}

  onClickExecuteFullResync(){
    this.isExecutingFullRescync = true;
    this.bankSvc.executeAccountsResyncJob()
    .subscribe({
      next: (data) => {
        this.isExecutingFullRescync = false;
        this._snackBar.open("Full resync job started!.", undefined, { duration: 5000 })

      },
      error: (err) => {
        this.isExecutingFullRescync = false;
        this._snackBar.open("Error occured requesting full resync job to start, please try again later.", undefined, { duration: 5000 })
      }
    });
  }
}
